import { FeatureFlag, selectActiveFeatureFlagsLookup } from 'state/slices/tenant/feature-flags.slice';
import useSelector from './useSelector';

export function useFeatureFlag(flag: FeatureFlag) {
    const featureFlags = useSelector(selectActiveFeatureFlagsLookup);
    return featureFlags.has(flag);
}

type FeatureSwitchProps = {
    flag: FeatureFlag;
    component?: JSX.Element | null;
    fallback?: JSX.Element | null;
};

/**
 * @description Handle component visibility based on a feature flag.
 * @param flag FeatureFlag to check
 * @param component Component to render if flag ON
 * @param fallback Component to render if flag is OFF (nullable)
 */
export function FeatureSwitch({ flag, component = null, fallback = null }: FeatureSwitchProps) {
    const flagIsOn = useFeatureFlag(flag);
    if (flagIsOn) return component;
    return fallback;
}
